import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">
          Let's build technology that works.
        </p>
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-info-item">
              <h4>Email</h4>
              <p>prelybeinternational2061@yahoo.com</p>
            </div>
            <div className="contact-info-item">
              <h4>Phone</h4>
              <p>+254721321674</p>
            </div>
            <div className="contact-info-item">
              <h4>Location</h4>
              <div className="locations">
                <div className="location-item">
                  <strong>Lodwar</strong>
                  <p>
                    Lodepe Building, opposite J-Pee Transporters, Kilimanjaro Rd.
                    <br />
                    P.O. Box 182-30500, Lodwar, Kenya
                  </p>
                </div>
                <div className="location-item">
                  <strong>Nakuru</strong>
                  <p>
                    Kenyatta Avenue, Pluto's Building, 3rd floor
                    <br />
                    P.O. Box 12318-20100, Nakuru
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

